import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody
} from "@material-ui/core";
import { useGetCustomerContractContactPersonQuery } from "@graphql";
import { ErrorCard, Spinner, PlainLink } from "@components";
import { useLocale } from "@hooks";

type Props = {
  id: string;
};

export function CustomerContractContactPerson(props: Props) {
  const { data, loading, error } = useGetCustomerContractContactPersonQuery({
    variables: { id: props.id },
    fetchPolicy: "cache-first"
  });

  const { locale } = useLocale();

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorCard message={error.message} title={error.name} />;
  }

  const { customerContractById: contract } = data;

  return (
    <TableContainer component={Paper}>
      <Table size="medium" unselectable="on">
        <TableHead>
          <TableRow>
            <TableCell>{locale.Title}</TableCell>
            <TableCell>{locale.Name}</TableCell>
            <TableCell>{locale.Phone}</TableCell>
            <TableCell>{locale.Email}</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {contract.contactPerson?.map((x, i) => (
            <TableRow key={i}>
              <TableCell style={styles.col}>{x?.title}</TableCell>
              <TableCell style={styles.col}>{x?.name}</TableCell>

              <TableCell style={styles.col}>
                {x?.phone && (
                  <PlainLink href={`tel:${x.phone}`} withIcon>
                    {x.phone}
                  </PlainLink>
                )}
              </TableCell>

              <TableCell style={styles.col}>
                {x?.email && (
                  <PlainLink href={`mailto:${x.email}`} withIcon>
                    {x.email}
                  </PlainLink>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const styles = {
  col: { borderBottom: 0 }
};
